var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useCallback, useEffect, useState } from 'react';
import { Chart as ReactChart } from 'react-chartjs-2';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
import { TranslatedText } from '../../atoms/TranslatedText';
import { ContentContainer } from '../../templates/ContentContainer';
import { ChartToggle } from './Chart.toggle';
import useOptionsParser from './useOptionsParser';
import { WaterfallChart } from './Waterfall/Waterfall';
import { withDataParsing } from './withDataParsing';
/**
 * Chart Wrapper for ChartJS library.
 * IMPORTANT: number of items of labels and datasets MUST match, otherwise you're going to have a weird looking chart.
 * @param design string ID for the design system
 * @param labels Array<string> array of labels.
 * @param datasets Array<object> array of objects containing data for the chart.
 * @returns Chart component
 */
export var BaseChart = function (_a) {
    var design = _a.design, labels = _a.labels, datasets = _a.datasets;
    var _b = useState(null), chartType = _b[0], setChartType = _b[1];
    var _c = useDesign(design), components = _c.components, config = _c.config, schema = _c.schema;
    var _d = config, type = _d.type, toggleableTypes = _d.toggleableTypes, datasetReferenceIndex = _d.datasetReferenceIndex, summary = _d.summary;
    var handleToggle = useCallback(function (newType) { return setChartType(newType); }, [setChartType]);
    var customLegend = Boolean(components.legend);
    var options = useOptionsParser(__assign(__assign({}, config), { customLegend: customLegend }));
    var data = { labels: labels, datasets: datasets };
    var ariaLabelledBy = config['aria-labelledby'] || components.title;
    useEffect(function () {
        if (!type || type === chartType)
            return;
        setChartType(type);
    }, [type]);
    if (!chartType || !data)
        return null;
    return (_jsxs(GenericComponent, __assign({ schema: schema, "data-design": design }, { children: [components.title ? _jsx(TranslatedText, { design: components.title, id: components.title }) : null, toggleableTypes ? (_jsx(ChartToggle, { active: chartType, design: components.toggle, types: toggleableTypes, onToggleClick: handleToggle })) : null, customLegend ? _jsx(ContentContainer, { design: components.legend, values: { chartType: chartType } }) : null, chartType === 'waterfall' ? (_jsx(WaterfallChart, __assign({ options: options, datasetReferenceIndex: datasetReferenceIndex, summaryLabel: summary === null || summary === void 0 ? void 0 : summary.label, summaryBackgroundColor: summary === null || summary === void 0 ? void 0 : summary.backgroundColor, "aria-labelledby": ariaLabelledBy }, data))) : (_jsx(ReactChart, { type: chartType, options: options, data: data, plugins: [ChartDataLabels], "aria-labelledby": ariaLabelledBy }))] })));
};
export var Chart = withDataParsing(BaseChart);
